export class ChartColumnCustomization {
  fieldName: string;
  titleKey: string;
  format?: () => string;

  public constructor(init?: Readonly<ChartColumnCustomization>) {
    Object.assign(this, init);
  }
}
